import {
  ColorModel,
  ProductAttributeWithOption,
  ProductAttributeMappingsInput,
  ProductItemModel,
  ProductVariantEditableModel,
} from "../../../../../shared/models";
import React, { FC } from "react";
import { inject, observer } from "mobx-react";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import {
  DescriptionCell,
  LabelCell,
  MainOuterCard,
} from "../../../../../shared/styles";
import { InputWithColorBox } from "../../../../../shared/components";
import { ItemsStore } from "../../../../../shared/store";

type IProps = {
  itemStore?: ItemsStore;
};

const AttributeSectionEditable: FC<IProps> = ({ itemStore }) => {
  if (!itemStore?.selectedProduct?.editableVariant?.attribute) return null;

  function updateVariant(index: number, name: string) {
      const cloned = itemStore?.selectedProduct?.editableVariant?.attribute?.attributeMappings?.map((attribute) => {
          return new ProductAttributeWithOption({ ...attribute });
      });

      if (!cloned) return;

      cloned[index].optionName = name;

      itemStore?.updateSelectedProduct(
          new ProductItemModel({
              ...itemStore.selectedProduct,
              editableVariant: new ProductVariantEditableModel({
                  ...itemStore?.selectedProduct?.editableVariant,
                  attribute: new ProductAttributeMappingsInput({
                      attributeMappings: cloned,
                  }),
              }),
          }),
      );
  }

  function showHideColorPicker(show: boolean, color: ColorModel, idx: number) {
      const cloned = itemStore?.selectedProduct?.editableVariant?.attribute?.attributeMappings?.map((attribute) => {
          return new ProductAttributeWithOption({ ...attribute });
      });

      if (!cloned) return;

      cloned[idx].isShowColorPicker = show;
      cloned[idx].color = color;
      itemStore?.updateSelectedProduct(
          new ProductItemModel({
              ...itemStore.selectedProduct,
              editableVariant: new ProductVariantEditableModel({
                  ...itemStore?.selectedProduct?.editableVariant,
                  attribute: new ProductAttributeMappingsInput({
                      attributeMappings: cloned,
                  }),
              }),
          }),
      );
  }
  return (
      <>
          <MainOuterCard margin="10px 0px" className="attribute-edit-panel">
              <CustomLabel fontSize="20px" fontWeight="600" color="#2C3E50" margin="0px 0px 25px">
                  Attributes
              </CustomLabel>
              <FlexContainer fxLayout="column" spacing={20}>
                  {itemStore?.selectedProduct?.editableVariant?.attribute?.attributeMappings?.map(
                      (attribute, idx) => {
                          const color = attribute.color || new ColorModel();
                          return (
                              <div key={idx}>
                                  <FlexContainer spacing={20} alignItems="center">
                                      <LabelCell>
                                          <CustomLabel>{attribute.attributeName}</CustomLabel>
                                      </LabelCell>
                                      <DescriptionCell>
                                          <InputWithColorBox
                                              value={attribute.optionName}
                                              onChange={(e) => updateVariant(idx, e.target.value)}
                                              onClick={() => showHideColorPicker(true, color, idx)}
                                              color={color}
                                              showColorBlock={attribute.valueType === 'Color'}
                                              showColorPicker={attribute.isShowColorPicker}
                                              onColorChange={(newColor) => showHideColorPicker(true, newColor, idx)}
                                              onHideColorPicker={() => showHideColorPicker(false, color, idx)}
                                          />
                                      </DescriptionCell>
                                  </FlexContainer>
                              </div>
                          );
                      },
                  )}
              </FlexContainer>
          </MainOuterCard>
      </>
  );
};
export default inject('itemStore')(observer(AttributeSectionEditable));
